import { useEffect, useState, useCallback } from 'react';
import { nextFeatureSelectionIdVar } from '../../../gqlCommon/graphql/cache';
import IFeaturesList from '../../model/IFeaturesList';
import useCustomizeCarContext from '../useCustomizeCarContext';
import useDxpDataLayer from '../../../common/hooks/useDxpDataLayer';

export const useSelectedColorFeatures = (featuresList: IFeaturesList) => {
  const { selectedCar, toggleFeature } = useCustomizeCarContext();
  const [colorSelectionCode, setColorSelectionCode] = useState<string>('');
  const [colorSelectionName, setColorSelectionName] = useState<string>('');
  const selectedFeaturesId = selectedCar?.selectedFeatures.selected;
  const { dxpHandleColorSelection } = useDxpDataLayer();

  useEffect(() => {
    if (selectedFeaturesId) {
      featuresList.features.forEach(feature => {
        if (selectedFeaturesId.includes(feature.code)) {
          const currentSelectedCode = selectedFeaturesId.find(featureId => featureId === feature.code);
          const currentSelectedName = featuresList.features.find(feature => currentSelectedCode === feature.code)?.name;

          setColorSelectionCode(currentSelectedCode);
          setColorSelectionName(currentSelectedName);
        }
      });
    }
  }, [selectedFeaturesId, featuresList]);

  const handleColorSelection = useCallback(
    (id: string, category?: string) => {
      const currentSelected = featuresList.features.find(feature => id === feature.code);
      setColorSelectionCode(currentSelected.code);
      setColorSelectionName(currentSelected.name);
      nextFeatureSelectionIdVar(id);

      toggleFeature(id);
      dxpHandleColorSelection(category, currentSelected.name);
    },
    [featuresList, toggleFeature, selectedFeaturesId, colorSelectionCode],
  );

  return { colorSelectionCode, colorSelectionName, handleColorSelection };
};
